import React from 'react';
import styled from 'styled-components';
import {Container} from '../styles/Grids';
import Img from '../components/Img';


import img_bg_1 from '../assets/img/bg_1_1.png';
import img_bg_2 from '../assets/img/bg_1_2.png';
import img_bg_3 from '../assets/img/bg_1_3.png';
import img_product from '../assets/img/PC3-6.png';
import img_btn_more from '../assets/img/PC3-7.png';
import img_btn_shop from '../assets/img/PC3-8.png';
import {NoStyleButton} from '../components/Button';
import {breakPoint} from '../styles/var';


const ContentStyles = styled.div`
  .container {
    padding: 4rem;
  }
  @media (min-width: ${breakPoint.min}) {
    .container {
      padding-top: 8rem;
    }
  }
  @media (max-width: ${breakPoint.smMax}) {
    .container {
      padding: 3rem 2rem;
    }
  }
`;
const WrapStyles = styled.div`
  max-width: 102rem;
  margin-right: auto;
  margin-left: auto;
  background-color: var(--bg);
  background-image: url(${img_bg_1}), url(${img_bg_3}), url(${img_bg_2});
  background-size: contain;
  background-position: left top, left bottom, left top;
  background-repeat: no-repeat, no-repeat, repeat-y;
  border-radius: 4%;
  overflow: hidden;
  padding: 3rem 3.5rem;
  @media (min-width: ${breakPoint.min}) {
    padding: 5rem 7rem;
  }
  @media (max-width: ${breakPoint.smMax}) {
    padding: 2.5rem 2rem;
  }
`;
const GridStyles = styled.div`
  display: grid;
  grid-template-columns: repeat(2, auto);
  grid-template-rows: repeat(2, auto);
  gap: 2rem;
  justify-content: center;
  align-items: center;
  .img {
    grid-row-start: 1;
    grid-row-end: 3;
  }
  .text {
    h3 {
      font-size: 2.1rem;
    }
    p {
      margin-bottom: 0;
    }
  }
  .btns {
    align-self: flex-start;
    display: flex;
    gap: 1rem;
  }
  @media (min-width: ${breakPoint.min}) {
    gap: 4rem;
    .text {
      h3 {
        font-size: 3rem;
      }
    }
  }
  @media (max-width: ${breakPoint.smMax}) {
    gap: 2rem 1rem;
    .img {
      grid-row-end: 1;
    }
    .text {
      h3 {
        font-size: 1.8rem;
      }
    }
    .btns {
      grid-column-start: 1;
      grid-column-end: 3;
      gap: 2rem;
    }
  }
`;
const Section4 = (props) => {
  return (
    <ContentStyles {...props}>
      <Container className="container">
        <h2 className="title center">風格單品Style</h2>
        <WrapStyles>
          <GridStyles>
            <Img src={img_product} auto wrapProps={{className: 'img'}}/>
            <div className="text">
              <h3>Baby Hug 4合1餐椅<br/>
                嬰兒安撫床Air版</h3>
              <p>【Baby Hug】系列，是安撫床、安撫椅、休閒椅，更是高腳餐椅！從初生開始，24小時溫柔呵護寶寶成長，成為新手爸媽力推的好幫手。全新進化推出AIR版~通風透氣的設計，使空氣循環流通，大大提升睡眠舒適度。</p>
            </div>
            <div className="btns">
              <NoStyleButton href="https://www.mombaby.com.tw/articles/9920299"><Img src={img_btn_more} auto wrapProps={{className: 'btn'}}/></NoStyleButton>
              <NoStyleButton href="https://bit.ly/3xrT9Tz"><Img src={img_btn_shop} auto wrapProps={{className: 'btn'}}/></NoStyleButton>
            </div>
          </GridStyles>
        </WrapStyles>
      </Container>
    </ContentStyles>
  )
};

export default Section4;
